import { useContext, useEffect } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { ModalApplicationMailingsUI } from './ui'
import { IActionApplicationMailing, IModalApplicationMailingsUI, IModalApplicationMailingsContainer } from './types'

import { useValue } from '@hooks/useValue'
import { useApplications } from '@api/applications/state'

import { NotificationContext, notifyOpen } from '@ui/notification/notification.provider'


/** Контейнер - Рассылки по заявке */
export const ModalApplicationMailingsContainer = ({isOpen, applicationID, handleButtonCancel}: IModalApplicationMailingsContainer) => {
    const notify = useContext(NotificationContext)

    const {
        actionSendTelegramClientInfo, actionSendTelegramEducationPlan, 
        actionSendTelegramClientDecisionLearn, actionSendTelegramClientDemoInfo, 
        actionSendTelegramClientRepeat, actionSendTelegramClientTrainingBegun, 
        actionSendTelegramClientNewYear, actionSendEmailClientInfo, actionCreateDemoAccess
    } = useApplications(useShallow(state => ({
        actionSendTelegramClientInfo: state.actionSendTelegramClientInfo,
        actionSendTelegramEducationPlan: state.actionSendTelegramEducationPlan,
        actionSendTelegramClientDemoInfo: state.actionSendTelegramClientDemoInfo,
        actionSendTelegramClientRepeat: state.actionSendTelegramClientRepeat,
        actionSendTelegramClientDecisionLearn: state.actionSendTelegramClientDecisionLearn,
        actionSendTelegramClientTrainingBegun: state.actionSendTelegramClientTrainingBegun,
        actionSendTelegramClientNewYear: state.actionSendTelegramClientNewYear,
        actionSendEmailClientInfo: state.actionSendEmailClientInfo,
        actionCreateDemoAccess: state.actionCreateDemoAccess,
    })))

    const actionMailingsList = useValue<IActionApplicationMailing[]>([
        {id: 7, name: 'Демо + Инфо', isCheck: false},
        {id: 8, name: 'Повторный клиент', isCheck: false},
        {id: 6, name: 'Демо-доступ', isCheck: false},
        {id: 1, name: 'Информация для клиента', isCheck: false},
        {id: 9, name: 'Учебный план', isCheck: false},
        {id: 2, name: 'Решение клиента обучаться', isCheck: false},
        {id: 3, name: 'Обучение уже началось', isCheck: false},
        {id: 4, name: 'Промо-акция', isCheck: false},
        {id: 5, name: 'На почту клиенту', isCheck: false},
        {id: 10, name: 'На почту клиенту + Демо', isCheck: false},
    ])

    useEffect(() => {
        if (!isOpen) {
            const updatedActionMailings: IActionApplicationMailing[] = actionMailingsList.value.map(item => {
                return { ...item, isCheck: false }
            })
    
            actionMailingsList.setValue(updatedActionMailings)
        }
    }, [isOpen]) // eslint-disable-line react-hooks/exhaustive-deps


    /** Функция по выбору рассылок */
    const onSelectString = (id: number) => {
        const updatedActionMailings: IActionApplicationMailing[] = actionMailingsList.value.map(item => {
            if (item.id === id) {
                return { ...item, isCheck: !item.isCheck }
            }
            return item
        })

        actionMailingsList.setValue(updatedActionMailings)
    }

    /** Функция по откравке рассылок */
    const handleButtonSended = () => {
        let sendOK: boolean = false

        // Проверяем, есть ли выбранные рассылки
        for (const item of actionMailingsList.value) {
            if (item.isCheck) sendOK = true
        }

        if (sendOK) {
            for (const item of actionMailingsList.value) {
                if (item.isCheck) {
                    switch (item.id) {
                        case 1: {
                            actionSendTelegramClientInfo(Number(applicationID)).then((res) => {
                                notify && notifyOpen(`${res.message}`, 'info', 2000, notify)
                            }) 
                            break
                        }
                        case 2: {
                            actionSendTelegramClientDecisionLearn(Number(applicationID)).then((res) => {
                                notify && notifyOpen(`${res.message}`, 'info', 2000, notify)
                            }) 
                            break
                        }
                        case 3: {
                            actionSendTelegramClientTrainingBegun(Number(applicationID)).then((res) => {
                                notify && notifyOpen(`${res.message}`, 'info', 2000, notify)
                            }) 
                            break
                        }
                        case 4: {
                            actionSendTelegramClientNewYear(Number(applicationID)).then((res) => {
                                notify && notifyOpen(`${res.message}`, 'info', 2000, notify)
                            }) 
                            break
                        }
                        case 5: {
                            actionSendEmailClientInfo(Number(applicationID), 0).then((res) => {
                                notify && notifyOpen(`${res.message}`, 'info', 2000, notify)
                            }) 
                            break
                        }
                        case 6: {
                            actionCreateDemoAccess(Number(applicationID)).then((res) => {
                                notify && notifyOpen(`${res.message}`, 'info', 2000, notify)
                            }) 
                            break
                        }
                        case 7: {
                            actionSendTelegramClientDemoInfo(Number(applicationID)).then((res) => {
                                notify && notifyOpen(`${res.message}`, 'info', 2000, notify)
                            }) 
                            break
                        }
                        case 8: {
                            actionSendTelegramClientRepeat(Number(applicationID)).then((res) => {
                                notify && notifyOpen(`${res.message}`, 'info', 2000, notify)
                            }) 
                            break
                        }
                        case 9: {
                            actionSendTelegramEducationPlan(Number(applicationID)).then((res) => {
                                notify && notifyOpen(`${res.message}`, 'info', 2000, notify)
                            }) 
                            break
                        }
                        case 10: {
                            actionSendEmailClientInfo(Number(applicationID), 1).then((res) => {
                                notify && notifyOpen(`${res.message}`, 'info', 2000, notify)
                            }) 
                            break
                        }
                    }
                }
            }

            handleButtonCancel && handleButtonCancel()
        } else {
            notify && notifyOpen('Необходимо выбрать хотя бы одну рассылку.', 'warning', 2000, notify)
        }
    }

    /** Свойства передаваемые в компоненту */
    const propsToComponent: IModalApplicationMailingsUI = {
        isOpen, 
        actionMailingsList, 
        
        onSelectString, 
        handleButtonSended,
        handleButtonCancel,
    }

    return <>
        <ModalApplicationMailingsUI {...propsToComponent} />
    </>
}